import React from 'react';
import Image from 'next/image';

import {
  Container,
  Title,
  CardGrid,
  Card,
  IconContainer,
  CardTitle,
  CardDescription,
  Divider,
} from './TrustReason.styles';

import useScreenSize from '@source/hooks/useScreenSize';
import { buildI18KeyResponsive, getResponsiveContent } from '@source/hooks/useResponsiveContent';
import { Trans } from 'next-i18next';

interface TrustReasonCardProps {
  icon: string;
  title: string;
  description: string;
}

interface TrustReasonProps {
  content: { title: string; ups: TrustReasonCardProps[] };
}

const TrustReason: React.FC<TrustReasonProps> = ({ content }) => {
  const { title, ups } = content;
  const breakpoint = useScreenSize();

  const tTitle = getResponsiveContent(buildI18KeyResponsive(title, ['xs', 'md', 'lg']), breakpoint);

  return (
    <Container>
      <Title>
        <Trans ns="sellCar" i18nKey={tTitle} defaults={title} />
      </Title>
      <CardGrid>
        {ups.map((reason: TrustReasonCardProps, index: number) => (
          <React.Fragment key={index}>
            <Card>
              <IconContainer>
                <Image
                  src={reason.icon}
                  alt={reason.title}
                  width={69}
                  height={69}
                  style={{ width: '100%', height: 'auto' }}
                />
              </IconContainer>
              <CardTitle>
                <Trans ns="sellCar" i18nKey={reason.title} />
              </CardTitle>
              <CardDescription>
                <Trans ns="sellCar" i18nKey={reason.description} />
              </CardDescription>
            </Card>
            {index < ups.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </CardGrid>
    </Container>
  );
};

export default TrustReason;
